module.exports = __webpack_public_path__ + "img/zzzlogo.82b9c7a5.png";